module.exports = __webpack_public_path__ + "media/ask/female-back-b404a0d6.svg";